/**
     * @desc 2分页查询上架的盲盒列表,两种:1系统盲盒,0用户盲盒NoAuth
用于：盲盒列表页，参数：count，pageSize, box.isSystem 是否系统盲盒，据此调用不同合约
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/searchBox', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/searchBox', params);
}
